import { Button, Small } from '@ahmdigital/ui';
import styled from 'styled-components';

const PriceBarWrapper = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  gap: 0.5rem;
  padding: 1rem;
  @media (min-width: ${({ theme }) => theme.media.md}) {
    gap: 1rem;
    flex-wrap: nowrap;
    border: none;
    max-width: ${({ theme }) => theme.media.md};
  }
`;

const SelectedProductsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1 1 0;
  min-width: 0;
  margin-right: 0.5rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin-right: unset;
    gap: 1rem;
    flex-direction: row;
    border: none;
    flex-basis: 0;
  }
`;

const TotalPriceWrapper = styled.div`
  display: flex;
  align-items: center;
  align-self: normal;
  flex-shrink: 0;
  height: auto;
  min-height: 85px;
  justify-content: center;
  border-left: 1px solid ${({ theme }) => theme.colors.grey20};
  flex-direction: column;
  flex-basis: min-content;
  min-width: 125px;
  padding-left: 1rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    padding-left: 1rem;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-basis: 100%;
  min-width: 200px;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    flex-direction: row;
    flex-basis: unset;
  }
`;

const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  font-size: 1.25rem;
  padding: 1rem;
`;

type ProductPriceWrapperProps = {
  isSelected?: boolean;
};

const ProductPriceWrapper = styled.div<ProductPriceWrapperProps>`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.25rem;
  color: ${({ theme, isSelected }) => (isSelected ? theme.colors.black : theme.colors.grey60)};
  background-color: ${({ theme, isSelected }) => (isSelected ? theme.colors.grey10 : theme.colors.white)};
  transition-property: background-color, color;
  transition-duration: 0.6s;
  transition-timing-function: cubic-bezier(0.09, 0.94, 0.42, 0.98);
  gap: 1rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};

  @media (min-width: ${({ theme }) => theme.media.md}) {
    padding: 1rem;
  }
`;

const PremiumReviewText = styled(Small)`
  width: 100%;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    text-align: left;
  }
`;

export {
  PriceBarWrapper,
  TotalPriceWrapper,
  SelectedProductsWrapper,
  ButtonWrapper,
  StyledButton,
  ProductPriceWrapper,
  PremiumReviewText,
};
